
(function seoSectionFrontend($, window) {
    $(document).on('cms.ready', ready);
    // $(document).ready(ready);

    let logged_in = false; // Nice-to-have: Logged in as a Contenda variable.

    function ready() {
        logged_in = $('body.logged-in').length;

        if(logged_in) {
            // Set up intersect listener on document since that's the only way we can listen to newly added elements
            $(document).on('cms.intersect', '.sectionSEO', function(evt, entry, $elm) {
                setupSection(0, $elm);
            });
        } else {
            $('.sectionSEO').each(setupSection);
        }

    }

    function setupSection(i, elm) {
        let $questions = $(elm).find('.faq-question');
        $questions.eq(0).attr('open','open');


        // close other questions when opening a new one
        $questions.click(function() {
            $(this).siblings().removeAttr('open');
        });
    }

})(jQuery, window);